// Firebase Configuration
import { initializeApp, getApps, getApp, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { initializeFirestore, Firestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyD28qvZuyCWl4jdXADgf1NC2W_D5IneqAs",
    authDomain: "padel-brothers.firebaseapp.com",
    projectId: "padel-brothers",
    storageBucket: "padel-brothers.firebasestorage.app",
    messagingSenderId: "1088734579262",
    appId: "1:1088734579262:web:fbe4242ad493a54b129f6f",
    measurementId: "G-PRG4376T09"
};

// ONE-TIME MIGRATION: Purge poisoned Firestore IndexedDB cache
// The old markAsRead fallback used setDoc() which created phantom documents
// in the persistent cache that keep reappearing as ghost notifications.
// This clears all Firestore-related IndexedDB databases to force a clean sync.
const CACHE_VERSION = 'pb_cache_v2';
if (!localStorage.getItem(CACHE_VERSION)) {
    console.log('[Migration] Purging Firestore IndexedDB cache to clear ghost notifications...');
    try {
        // Delete all Firestore-related IndexedDB databases
        if (typeof indexedDB !== 'undefined' && indexedDB.databases) {
            indexedDB.databases().then(dbs => {
                dbs.forEach(dbInfo => {
                    if (dbInfo.name && (
                        dbInfo.name.includes('firestore') ||
                        dbInfo.name.includes('firebase') ||
                        dbInfo.name.includes('firebaseLocalStorage')
                    )) {
                        console.log(`[Migration] Deleting IndexedDB: ${dbInfo.name}`);
                        indexedDB.deleteDatabase(dbInfo.name);
                    }
                });
            });
        }
    } catch (e) {
        console.warn('[Migration] IndexedDB cleanup failed:', e);
    }
    localStorage.setItem(CACHE_VERSION, 'done');
}

let app: FirebaseApp;
let auth: Auth;

try {
    // 1. Initialize App or get existing one
    if (getApps().length === 0) {
        app = initializeApp(firebaseConfig);
    } else {
        app = getApp();
    }

    // 2. Initialize Auth
    auth = getAuth(app);

} catch (error) {
    console.error("CRITICAL: Firebase initialization failed", error);
    // Fallback to prevent app crash on import
    // @ts-ignore
    if (!app) app = initializeApp(firebaseConfig);
    try {
        // @ts-ignore
        if (!auth) auth = getAuth(app);
    } catch (e) {
        console.error("Auth init failed in fallback", e);
    }
}

// Initialize Firestore with persistent cache (new API, no deprecation warning)
const db: Firestore = initializeFirestore(app!, {
    localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager()
    })
});

const storage = getStorage(app!);
const functions = getFunctions(app!, 'europe-west1');

export { auth, db, storage, functions };
export default app!;

